import styles from "./navigation-bar-checkout-button.module.css";
import { UIIconButton } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-button";
import { useCheckout } from "BEDROCK/pages/checkout/checkout-provider";
import { filterClasses } from "PosterEditor/utils/filter-classes";
import { useAppScroll } from "use-app-scroll";

interface NavigationBarCheckoutButtonProps {
  numberOfItems: number;
  onClick: () => void;
}

export const NavigationBarCheckoutButton = (
  props: NavigationBarCheckoutButtonProps
) => {
  const { scrolled } = useAppScroll();
  const { isEmpty: isCheckoutEmpty, checkout } = useCheckout();

  const count = checkout?.items.length || 0;
  const countString = count.toString();
  let countClass = "";
  if (countString.length === 3) {
    countClass = styles.smaller;
  } else if (countString.length === 2) {
    countClass = styles.small;
  }

  const buttonVariant = "REGULAR"; //scrolled ? "REGULAR" : "CONTRAST";
  const countColorClass = styles.countRegular; // scrolled ? styles.countRegular : styles.countContrast;

  return (
    <div className={styles.container}>
      <UIIconButton
        iconName="BAG"
        onClick={props.onClick}
        variant={buttonVariant}
        width={30}
        unclickable={isCheckoutEmpty}
        disabled={isCheckoutEmpty}
      />
      {!isCheckoutEmpty && (
        <>
          <div
            className={filterClasses(
              styles.checkoutCount,
              countClass,
              countColorClass
            )}
          >
            <span>{count}</span>
          </div>
        </>
      )}
    </div>
  );
};
